/* eslint-disable @typescript-eslint/no-explicit-any */
import { atom } from 'jotai';
import { ParamsConfigServices } from 'src/libs/services/params-config.service';

export const paramsConfigGlobalAtom = atom<any>(null);

export const getParamsConfigGlobalAtom = atom(
  null,
  async (get, set) => {
    const response = await ParamsConfigServices.getAllParamsConfig();
    const data = response.data;
    set(paramsConfigGlobalAtom, data);
  }
);

export const OpenModalConfig = atom<boolean>(false);
export const TabActiveModalConfig = atom<string>('1');